import React from "react";
import { FieldArray, useField } from "formik";
import { errorMessages } from "./FieldFeedback";

const AAHasMany = ({ name, label, items = [], render, newItem = {}, ...props }) => {
  const [, meta] = useField({ ...props, name });
  const errors = errorMessages(meta.error);

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <React.Fragment>
          <h3>{label}</h3>
          {errors.map((e, index) => (
            <p key={`${index}-${e}`} className="common-error signal-form-error" data-signal-name={name}>{e}</p>
          ))}
          <fieldset className="inputs prescription_medicines_subform" data-signal-collection="" data-signal-name={name} data-signal-label={label}>
            <ol>
              <li className="has_many_container">
                {items.length > 0 &&
                  items.map((child, index) => (
                    <fieldset key={index} className="inputs has_many_fields">
                      <ol>
                        {render(child, index)}
                        <li className="signal-has-many-actions">
                          <button
                            type="button"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            Удалить
                          </button>
                        </li>
                      </ol>
                    </fieldset>
                  ))}
              </li>

              <button
                type="button"
                onClick={() => arrayHelpers.push(newItem)}
              >
                Добавить
              </button>
            </ol>
          </fieldset>
        </React.Fragment>
      )}
    />
  );
};

export default AAHasMany;
